<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Configure connector</h1>

                    <a :href="`/#/admin/integrations/connectors/details/${id}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="row">
                <div v-for="p in providers" class="col col-4">
                    <div @click="providerType=p.Type" class="card text-dark bg-light mb-3" role="button" :class="{ 'border-primary': providerType == p.Type }">
                        <img v-if="p.LogoUrl" class="card-img-top m-1" :src="p.LogoUrl" style="max-height: 100px;">
                        <div class="card-body">
                            <h5 class="card-title">{{p.Name}}</h5>
                            <p class="card-text">{{p.Description}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <br />

            <iframe v-if="provider"
                    ref="connectorProviderElement"
                    name="connectorProviderElement"
                    :src="configPageUrl"
                    style="border: none; width: 100%; height: 600px;">
            </iframe>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { guid } from "@app/Guid"
    import { useId } from '@common/composables'
    import { useAdminConfigureConnectorPage } from '@Integrations/Connectors/pages-core'

    document.title = "Configure connector"

    const id = useId()
    const { useCurrentUserQuery, useConnectorProvidersQuery, useConnectorDetailsQuery, useConfigureConnectorCommand } = useAdminConfigureConnectorPage()

    const connectorProviderElement = ref<HTMLIFrameElement>(null)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runConnectorDetailsQueryV1, modelConnectorDetailsQueryV1 } = useConnectorDetailsQuery(id)
    const tid = computed(() => modelConnectorDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelConnectorDetailsQueryV1.value?.Name)
    const configPageUrl = computed(() => `${provider.value?.ConfigPageUrl}${tid.value}`)
    const connectorProviderType = computed(() => modelConnectorDetailsQueryV1.value?.ConnectorProvider?.Type)
    const connectorConfig = computed(() => modelConnectorDetailsQueryV1.value?.Config)

    const { runConnectorProvidersQueryV1, modelConnectorProvidersQueryV1 } = useConnectorProvidersQuery(true, true)

    const { invokeConfigureConnectorCommandV1, providerType, config, succeedConfigureConnectorCommandV1 } = useConfigureConnectorCommand(id, tid, userId)

    const connectorId = computed(() => modelConnectorDetailsQueryV1.value?.ConnectorId || guid())
    const providers = computed(() => modelConnectorProvidersQueryV1.value?.Providers)
    const provider = computed(() => providers.value?.find(_ => _.Type == providerType.value))

    watch(connectorProviderType, (val) => {
        providerType.value = connectorProviderType.value
    })

    watch(tid, (val) => {
        runConnectorProvidersQueryV1()
    })

    watch(succeedConfigureConnectorCommandV1, () => {
        if (succeedConfigureConnectorCommandV1.value) location.href = `/#/admin/integrations/connectors/details/${id}`
    })

    function onMessage(event) {
        if ((event.source as any)?.frameElement?.name == 'connectorProviderElement') {
            if (event.data?.type == 'Integrations.Connectors.ReadConfig') {
                // set current config once connector iframs is ready
                connectorProviderElement.value?.contentWindow?.postMessage({
                    'type': 'Integrations.Connectors.InitConfig',
                    'data': connectorConfig.value
                })
            }
            else if (event.data?.type == 'Integrations.Connectors.ApplyConnectorConfig') {
                config.value = JSON.stringify(event.data.data);
                invokeConfigureConnectorCommandV1()
            }
        }
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorDetailsQueryV1()
        window.addEventListener('message', onMessage);
    })

    onUnmounted(() => {
        window.removeEventListener('message', onMessage);
    })
</script>